import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import {TokenCommonService} from '../token-common.service';
import {AuthService} from '../auth/auth.service';

@Injectable()
export class DocumentoService extends TokenCommonService {

  constructor(
    http: Http,
    authService: AuthService
  ) {
    super(http, authService);
  }

  gatAll(params?: any) {
    return this.tokenGet(`${ environment.API_URL }documentos`, params);
  }

  edit(id, data: FormData) {
    return this.tokenPut(`${ environment.API_URL }documentos/${id}`, data);
  }

  create(data: FormData) {
    return this.tokenPost(`${ environment.API_URL }documentos`, data);
  }

  delete(id) {
    return this.tokenDelete(`${ environment.API_URL }documentos/${id}`);
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/documento/documento.service.ts